import * as React from 'react';

function SvgMessengerColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="MessengerColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={3}
        y={3}
        width={24}
        height={24}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 3h23.875v24H3V3z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#MessengerColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.124 17.963l-3.04-3.26-5.932 3.26L13.677 11l3.114 3.26L22.65 11l-6.525 6.963zM14.938 3C8.345 3 3 7.975 3 14.111c0 3.497 1.736 6.616 4.449 8.652V27l4.064-2.242c1.085.301 2.234.464 3.425.464 6.592 0 11.937-4.974 11.937-11.11C26.875 7.974 21.53 3 14.937 3z"
          fill="#0084FF"
        />
      </g>
    </svg>
  );
}

export default SvgMessengerColour;
